import { Box, Paper, Skeleton, Stack } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const cardSx = (radius: number) => ({
  p: 2.5,
  borderRadius: `${radius}px`,
  borderColor: 'divider',
  display: 'flex',
  flexDirection: 'column',
  gap: 1.75,
})

/** Loading skeleton mirroring the populated dashboard layout. */
export default function DashboardSkeleton() {
  const theme = useTheme()
  const r = theme.affexy.radii

  return (
    <Stack spacing={3} sx={{ maxWidth: 1340, mx: 'auto' }}>
      <Stack spacing={2}>
        <Box>
          <Skeleton variant="text" width={220} height={16} />
          <Skeleton variant="text" width={340} height={40} />
        </Box>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1.35fr 1fr 1fr 1fr' }, gap: 1.75 }}>
          {[0, 1, 2, 3].map((i) => (
            <Paper key={i} variant="outlined" sx={{ ...cardSx(r.md), minHeight: 132, gap: 1.5 }}>
              <Skeleton variant="text" width={120} height={12} />
              <Skeleton variant="text" width={90} height={32} />
              <Skeleton variant="text" width={80} height={12} />
            </Paper>
          ))}
        </Box>
      </Stack>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1.4fr 1fr' }, gap: 3 }}>
        {[0, 1].map((i) => (
          <Paper key={i} variant="outlined" sx={cardSx(r.lg / 1.33)}>
            <Skeleton variant="text" width={160} height={20} />
            {[0, 1, 2, 3].map((j) => (
              <Box key={j} sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                <Skeleton variant="circular" width={28} height={28} />
                <Box sx={{ flex: 1 }}>
                  <Skeleton variant="text" width="80%" height={14} />
                  <Skeleton variant="text" width="40%" height={12} />
                </Box>
              </Box>
            ))}
          </Paper>
        ))}
      </Box>

      <Paper variant="outlined" sx={cardSx(r.lg / 1.33)}>
        <Skeleton variant="text" width={160} height={20} />
        {[0, 1, 2, 3, 4].map((j) => (
          <Skeleton key={j} variant="rounded" height={28} />
        ))}
      </Paper>
    </Stack>
  )
}
